class RaqForm {
  constructor(el) {
    this.el = el;
    this.submitListener();
    this.errorListener();
  }

  submitListener() {
    var form = this.el;
    window.addEventListener('raqFormSubmitted', function() {
      form.scrollIntoView({behavior: "smooth"});
    });
  }
  errorListener() {
    var form = this.el;
    window.addEventListener('raqFormFailed', function() {
      var error = form.querySelector('.a-raqFormError');
      if (error) {
        error.scrollIntoView({behavior: "smooth", block: "center"});
      }
    });
  }
}

window.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector(".o-raqFormWrapper");
  if (form) {
    new RaqForm(form);
  }

});